import { MockPath } from "@library/common/http/mock-path.mock";

export const QuotationsRoutes: MockPath<unknown>[] = [
    {
        path: 'quotations/create',
        verb: 'POST',
        collection: () => [ '123456789' ],
    },
];